export const MOBILE_SORTS = [
  {
    label: 'offerSorts.ourRecommendation',
    value: 'effective_monthly_price',
  },
  {
    label: 'offerSorts.lowestPrice',
    value: 'lowest_price',
  },
  {
    label: 'offerSorts.absoluteSavingsAmount',
    value: 'absolute_savings_amount',
  },
  {
    label: 'offerSorts.percentageSavings',
    value: 'percentage_savings',
  },
]

export const HOME_SORTS = MOBILE_SORTS
export const BUNDLE_SORTS = MOBILE_SORTS
